import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-selected-ages',
  templateUrl: './selected-ages.component.html',
  styleUrls: ['./selected-ages.component.scss']
})
export class SelectedAgesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
